import {
  isSearchAnalyticsProjectInputErrorText,
  SearchAnalyticsProjectInputError,
} from "./get-search-analytics-aggregated-data/project-input-error";

const DEFAULT_TOOL_ERROR_TEXT = "An error occurred.";

/**
 * tool error を UI に保存できる文言へ変換する。
 *
 * 未知の例外は内部情報を伏せ、model が修正可能と確認済みの入力不整合だけを
 * 個別 tool の契約に沿って公開する。
 */
export function toolErrorTextForUI(error: unknown): string {
  if (error instanceof SearchAnalyticsProjectInputError) {
    return error.message;
  }
  return DEFAULT_TOOL_ERROR_TEXT;
}

/**
 * client が受け取った tool failure を Bugsnag に通知すべきか判定する。
 *
 * server が分類して UI へ公開した修正可能な入力不整合だけを通知対象外にし、
 * 同じ文言でも別 tool 由来の失敗や未知の失敗は通知する。
 */
export function shouldReportToolFailure(
  toolName: string,
  errorText: string | undefined,
): boolean {
  return !isSearchAnalyticsProjectInputErrorText(toolName, errorText);
}
